import { useMutation } from "@tanstack/react-query";

import { PreparedDestination } from "@prequel/react";

import DestinationService from "@/api/services/destinations";
import { MagicLinkArgs } from "@/api/services/magic-links";

export function useTestDestination() {
  return useMutation({
    mutationFn: (payload: { magiclinkargs: MagicLinkArgs; destination: PreparedDestination }) =>
      DestinationService.postTestDestination(payload),
  });
}

export function useCreateDestination() {
  return useMutation({
    mutationFn: (payload: { magiclinkargs: MagicLinkArgs; destination: PreparedDestination }) =>
      DestinationService.postDestination(payload),
  });
}
